import { useState } from "react";
import { useSEO } from "@/hooks/use-seo";
import { ArrowRight, Smartphone, Wifi, Shield, AlertTriangle, ChevronDown, ChevronUp, CreditCard, Monitor, Download, HelpCircle, CheckCircle, XCircle, Lock, BookOpen, Gamepad2, Zap, Calendar, Award, Clock, Headphones } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";

import logo1 from "@assets/logos_extracted/1.png";
import logo2 from "@assets/logos_extracted/2.png";
import logo3 from "@assets/logos_extracted/3.png";
import logo4 from "@assets/logos_extracted/4.png";
import logo5 from "@assets/logos_extracted/5.png";
import logo6 from "@assets/logos_extracted/6.png";
import logo7 from "@assets/logos_extracted/7.png";
import logo8 from "@assets/logos_extracted/8.png";
import logo9 from "@assets/logos_extracted/9.png";
import logo10 from "@assets/logos_extracted/10.png";
import logo11 from "@assets/logos_extracted/11.png";
import logo12 from "@assets/logos_extracted/12.png";
import logo13 from "@assets/logos_extracted/13.png";
import logo14 from "@assets/logos_extracted/14.png";
import logo15 from "@assets/logos_extracted/15.png";
import logo16 from "@assets/logos_extracted/16.png";
import logo17 from "@assets/logos_extracted/17.png";
import logo18 from "@assets/logos_extracted/18.png";
import logo19 from "@assets/logos_extracted/19.png";
import logo20 from "@assets/Untitled_design_(24)_1773076880991.png";

const CASINOS = [
  { name: "Rabona", logo: logo7, hasApp: true, platforms: "Android, iOS", bonus: "až 12 500 Kč + 200 FS", url: "https://rbn.fynkelto.com/?mid=279656_1645828", reviewUrl: "/kasina/rabona" },
  { name: "OnlySpins", logo: logo1, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://ons.lynmonkel.com/?mid=279656_1882080", reviewUrl: "/kasina/onlyspins" },
  { name: "Allyspin", logo: logo2, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 25 000 Kč + 200 FS", url: "https://all.monvaki.com/?mid=282906_1667056", reviewUrl: "/kasina/allyspin" },
  { name: "Legiano", logo: logo3, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://lgno.monvaki.com/?mid=282906_1666929", reviewUrl: "/kasina/legiano" },
  { name: "Bassbet", logo: logo4, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://bsbt.fynkelto.com/?mid=279656_1645822", reviewUrl: "/kasina/bassbet" },
  { name: "FastSlots", logo: logo5, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 125 000 Kč + 50 FS", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/fastslots" },
  { name: "Spinanga", logo: logo6, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://spng.fynkelto.com/?mid=279656_1645837", reviewUrl: "/kasina/spinanga" },
  { name: "Casinia", logo: logo8, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://csn.fynkelto.com/?mid=279656_1645832", reviewUrl: "/kasina/casinia" },
  { name: "Stone Vegas", logo: logo9, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://stnvgs.fynkelto.com/?mid=308616_1816138", reviewUrl: "/kasina/stone-vegas" },
  { name: "Golden Panda", logo: logo10, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 125 000 Kč + 50 FS", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/golden-panda" },
  { name: "Instant Casino", logo: logo11, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 185 000 Kč + 10% cashback", url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/instant-casino" },
  { name: "Boaboa", logo: logo12, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://bbaw.monvaki.com/?mid=282906_1667067", reviewUrl: "/kasina/boaboa" },
  { name: "Alf Casino", logo: logo13, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 20 000 Kč + 300 FS", url: "https://alcw.monvaki.com/?mid=282906_1667062", reviewUrl: "/kasina/alf-casino" },
  { name: "Cadoola", logo: logo14, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://cadw.monvaki.com/?mid=282906_1667064", reviewUrl: "/kasina/cadoola" },
  { name: "Bankonbet", logo: logo15, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://bnkw.monvaki.com/?mid=282906_1667060", reviewUrl: "/kasina/bankonbet" },
  { name: "Wazamba", logo: logo16, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://wzbw.monvaki.com/?mid=282906_1667059", reviewUrl: "/kasina/wazamba" },
  { name: "SPINiT", logo: logo17, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://swp.fynkelto.com/?mid=279656_1645821", reviewUrl: "/kasina/spinit" },
  { name: "SG Casino", logo: logo18, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 20 000 Kč + 250 FS", url: "https://sgc.monvaki.com/?mid=282906_1667053", reviewUrl: "/kasina/sg-casino" },
  { name: "Librabet", logo: logo19, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://lrb.fynkelto.com/?mid=279656_1645829", reviewUrl: "/kasina/librabet" },
  { name: "Nomini", logo: logo20, hasApp: false, platforms: "Mobilní prohlížeč", bonus: "až 12 500 Kč + 200 FS", url: "https://nmn.fynkelto.com/?mid=279656_1645825", reviewUrl: "/kasina/nomini" },
];

const FAQ = [
  {
    q: "Je lepší hrát přes mobilní aplikaci nebo prohlížeč?",
    a: "Obojí má své výhody. Aplikace nabízí rychlejší načítání, push notifikace a optimalizovaný výkon. Prohlížečové kasino nevyžaduje instalaci, zabírá méně místa v paměti a je okamžitě přístupné z jakéhokoli zařízení. Pro většinu hráčů je mobilní prohlížeč dostatečný.",
  },
  {
    q: "Které kasino má skutečnou mobilní aplikaci?",
    a: "Z námi recenzovaných kasin má Rabona jako jediné plnohodnotnou nativní aplikaci pro Android a iOS. Všechna ostatní kasina fungují jako mobilně optimalizované webové stránky, které se chovají velmi podobně jako aplikace.",
  },
  {
    q: "Jsou mobilní kasina bezpečná?",
    a: "Ano, pokud hrajete u licencovaného kasina. Mobilní verze používají stejné SSL šifrování a bezpečnostní protokoly jako desktopová verze. Navíc moderní prohlížeče na Androidu i iOS přidávají další vrstvu zabezpečení.",
  },
  {
    q: "Mohu na mobilu hrát live kasino?",
    a: "Ano, většina live kasinových her (ruleta, blackjack, baccarat) je plně optimalizována pro mobilní zařízení. Doporučujeme stabilní Wi-Fi připojení pro plynulý přenos videa. Některé hry umožňují i přepnutí do režimu na výšku pro pohodlnější ovládání.",
  },
  {
    q: "Jaké platební metody mohu použít na mobilu?",
    a: "Na mobilních zařízeních můžete využít všechny běžné platební metody — platební karty, e-peněženky (Skrill, Neteller), kryptoměny a navíc mobilní platby jako Apple Pay a Google Pay, které na desktopu často nejsou dostupné.",
  },
  {
    q: "Fungují bonusy i na mobilní verzi?",
    a: "Ano, všechny bonusy a promo akce platí bez ohledu na to, zda hrajete z desktopu, mobilu nebo tabletu. Některá kasina dokonce nabízejí exkluzivní mobilní bonusy jako odměnu za hraní na cestách.",
  },
  {
    q: "Kolik dat spotřebuje hraní na mobilu?",
    a: "Běžné sloty spotřebují přibližně 10–50 MB za hodinu hraní. Live kasino je datově náročnější — počítejte s 300–500 MB za hodinu kvůli streamování videa. Pro delší herní sessions doporučujeme Wi-Fi připojení.",
  },
];

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#eef1f7] last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 text-left gap-4"
        data-testid={`faq-${q.slice(0, 20).replace(/\s/g, "-")}`}
      >
        <span className="font-semibold text-gray-900 text-sm">{q}</span>
        {open ? <ChevronUp className="w-4 h-4 text-[#003da5] flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />}
      </button>
      {open && <p className="text-gray-600 text-sm leading-relaxed pb-4">{a}</p>}
    </div>
  );
}

export default function MobilniPage() {
  useSEO({ title: "Mobilní Kasino 2026 – Nejlepší casino na telefon | HrajBonus", description: "Hrajte casino kdekoliv na mobilu nebo tabletu. Top mobilní kasina s bonusy, aplikacemi pro Android a iOS a rychlými výplatami. 18+",
  url: "https://hrajbonus.com/kasina/mobilni", });

  return (
    <div className="min-h-screen bg-[#f5f7fb]">
      <Header />

      <section className="relative pt-16 pb-0 overflow-hidden">
        <div className="absolute inset-0 z-0" style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }} />
        <div className="absolute inset-0 z-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "40px 40px" }} />
        <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-14 sm:py-16 text-center">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-5">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-white/80 text-xs font-semibold uppercase tracking-widest">
              <Smartphone className="w-3.5 h-3.5 text-[#f5c518]" /> Mobilní kasina 2026
            </div>
            <div className="inline-flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 text-white/70 text-xs font-semibold" data-testid="badge-aktualizovano-mobilni">
              <Calendar className="w-3 h-3" /> Aktualizováno: 12. března 2026
            </div>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-white leading-tight mb-4" data-testid="heading-mobilni">
            Mobilní kasina — hrajte kdykoli a odkudkoli
          </h1>
          <p className="text-white/75 text-lg leading-relaxed max-w-2xl mx-auto mb-8">
            Přehled kasin optimalizovaných pro mobilní zařízení. Zjistěte, která kasina mají nativní aplikaci, která fungují skvěle v prohlížeči, a co všechno můžete na mobilu hrát.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="#casino-list">
              <Button size="default" className="hraj-btn font-bold gap-2" style={{ background: "#ffffff", color: "#003da5" }} data-testid="button-hero-list-mobilni">
                Zobrazit kasina <ArrowRight className="hraj-arrow w-4 h-4" />
              </Button>
            </a>
            <a href="#app-vs-browser">
              <Button size="default" variant="outline" className="hraj-btn border-white/30 text-white font-semibold" style={{ background: "rgba(255,255,255,0.08)" }}>
                Aplikace vs. prohlížeč
              </Button>
            </a>
          </div>
        </div>
        <div className="relative z-10">
          <svg viewBox="0 0 1440 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" style={{ display: "block", verticalAlign: "bottom", height: "44px" }}>
            <rect x="0" y="40" width="1440" height="4" fill="#f5f7fb" />
            <path d="M0 44L1440 44L1440 0C1200 35 720 40 0 0L0 44Z" fill="#f5f7fb" />
          </svg>
        </div>
      </section>

        <CasinoBreadcrumb casinoName="Mobilní kasina" />

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 space-y-10">

        <section>
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 shadow-sm">
            <div className="flex items-start gap-3">
              <Smartphone className="w-6 h-6 text-[#003da5] mt-0.5 flex-shrink-0" />
              <div>
                <h2 className="text-xl font-black text-gray-900 mb-2" data-testid="heading-info-block">Mobilní aplikace vs. mobilní prohlížeč — důležité rozlišení</h2>
                <p className="text-gray-700 text-sm leading-relaxed mb-3">
                  Na trhu existují dva typy mobilních kasin a je důležité je rozlišovat:
                </p>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-white rounded-xl p-4 border border-blue-100">
                    <div className="flex items-center gap-2 mb-2">
                      <Download className="w-4 h-4 text-[#003da5]" />
                      <h3 className="font-bold text-gray-900 text-sm">Nativní aplikace</h3>
                    </div>
                    <p className="text-gray-600 text-xs leading-relaxed">
                      Samostatná aplikace ke stažení z App Store / Google Play (nebo APK). Nabízí push notifikace, rychlejší načítání a optimalizovaný výkon. Z námi recenzovaných kasin má nativní aplikaci pouze <span className="font-bold text-[#003da5]">Rabona</span>.
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-4 border border-blue-100">
                    <div className="flex items-center gap-2 mb-2">
                      <Wifi className="w-4 h-4 text-[#003da5]" />
                      <h3 className="font-bold text-gray-900 text-sm">Mobilní prohlížeč (PWA)</h3>
                    </div>
                    <p className="text-gray-600 text-xs leading-relaxed">
                      Webová stránka plně optimalizovaná pro mobilní zařízení. Nevyžaduje instalaci, funguje ve všech prohlížečích (Chrome, Safari, Firefox). Většina moderních kasin tímto způsobem nabízí srovnatelný zážitek s nativní aplikací.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="app-vs-browser">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <Download className="w-5 h-5 text-[#003da5]" /> Výhody nativní aplikace
              </h2>
              <ul className="space-y-3">
                {[
                  { title: "Push notifikace", desc: "Upozornění na nové bonusy, turnaje a promo akce přímo na obrazovce" },
                  { title: "Rychlejší načítání", desc: "Aplikace uchovává data lokálně, takže se hry načítají svižněji" },
                  { title: "Biometrické přihlášení", desc: "Přihlášení otiskem prstu nebo Face ID pro rychlý a bezpečný přístup" },
                  { title: "Stabilnější připojení", desc: "Lepší správa síťového připojení a automatické obnovení při výpadku" },
                ].map(item => (
                  <li key={item.title} className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <span className="font-semibold text-gray-900 text-sm">{item.title}</span>
                      <p className="text-gray-500 text-xs mt-0.5">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <Wifi className="w-5 h-5 text-[#003da5]" /> Výhody mobilního prohlížeče
              </h2>
              <ul className="space-y-3">
                {[
                  { title: "Žádná instalace", desc: "Stačí otevřít web v prohlížeči — žádné stahování, žádné aktualizace" },
                  { title: "Nezabírá místo", desc: "Veškerý obsah se načítá ze serveru, nespotřebovává úložiště telefonu" },
                  { title: "Kompatibilita", desc: "Funguje na jakémkoli zařízení s moderním prohlížečem — Android, iOS, tablet" },
                  { title: "Okamžité aktualizace", desc: "Nové funkce a hry jsou dostupné ihned bez nutnosti aktualizace aplikace" },
                ].map(item => (
                  <li key={item.title} className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <span className="font-semibold text-gray-900 text-sm">{item.title}</span>
                      <p className="text-gray-500 text-xs mt-0.5">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4 flex items-center gap-2">
              <Monitor className="w-5 h-5 text-[#003da5]" /> Kompatibilita zařízení
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Mobilní kasina jsou navržena tak, aby fungovala na široké škále zařízení. Zde je přehled kompatibility:
            </p>
            <div className="grid sm:grid-cols-3 gap-4">
              {[
                {
                  device: "Android",
                  versions: "Android 8.0+",
                  browsers: "Chrome, Firefox, Samsung Internet",
                  note: "Plná kompatibilita. Aplikace Rabona dostupná jako APK ke stažení přímo z webu kasina.",
                },
                {
                  device: "iOS (iPhone/iPad)",
                  versions: "iOS 14+",
                  browsers: "Safari, Chrome",
                  note: "Plná kompatibilita. Aplikace Rabona dostupná v App Store. Webová kasina lze přidat na plochu jako zkratku.",
                },
                {
                  device: "Tablet",
                  versions: "Android/iPadOS",
                  browsers: "Všechny moderní prohlížeče",
                  note: "Optimální zážitek díky větší obrazovce. Ideální pro live kasino a stolní hry.",
                },
              ].map(d => (
                <div key={d.device} className="bg-[#f3f6fb] rounded-xl p-4">
                  <h3 className="font-bold text-gray-900 text-sm mb-2">{d.device}</h3>
                  <div className="space-y-1 text-xs">
                    <p className="text-gray-600"><span className="font-semibold text-gray-700">Verze:</span> {d.versions}</p>
                    <p className="text-gray-600"><span className="font-semibold text-gray-700">Prohlížeče:</span> {d.browsers}</p>
                    <p className="text-gray-500 mt-2 italic">{d.note}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4 flex items-center gap-2">
              <CreditCard className="w-5 h-5 text-[#003da5]" /> Platby na mobilních zařízeních
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5">
              Mobilní kasina podporují všechny běžné platební metody a navíc nabízejí mobilně specifické možnosti:
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { cat: "Mobilní platby", methods: "Apple Pay, Google Pay", icon: "📱", note: "Nejrychlejší vklady — potvrzení otiskem nebo Face ID" },
                { cat: "E-peněženky", methods: "Skrill, Neteller, MiFinity", icon: "💳", note: "Vklady i výběry, rychlé zpracování" },
                { cat: "Kryptoměny", methods: "Bitcoin, Ethereum, Tether", icon: "🪙", note: "Ideální pro mobilní hráče — skenování QR kódu" },
                { cat: "Platební karty", methods: "Visa, Mastercard", icon: "🏦", note: "Standardní metoda, okamžité vklady" },
              ].map(pm => (
                <div key={pm.cat} className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="text-2xl mb-2">{pm.icon}</div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1">{pm.cat}</h3>
                  <p className="text-gray-700 text-xs mb-2">{pm.methods}</p>
                  <p className="text-gray-500 text-xs italic">{pm.note}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section>
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-4 flex items-center gap-2">
              <Gamepad2 className="w-5 h-5 text-[#003da5]" /> Live kasino na mobilních zařízeních
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Live kasino je plně dostupné na mobilních zařízeních. Přenos videa z profesionálních studií funguje v reálném čase a kvalita se automaticky přizpůsobuje rychlosti vašeho připojení.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#f3f6fb] rounded-xl p-4">
                <h3 className="font-bold text-gray-900 text-sm mb-2">Dostupné hry</h3>
                <ul className="space-y-1 text-gray-600 text-sm">
                  <li className="flex items-center gap-2"><Zap className="w-3 h-3 text-[#003da5]" /> Live ruleta (Lightning, Immersive, Auto)</li>
                  <li className="flex items-center gap-2"><Zap className="w-3 h-3 text-[#003da5]" /> Live blackjack (Classic, VIP, Infinite)</li>
                  <li className="flex items-center gap-2"><Zap className="w-3 h-3 text-[#003da5]" /> Live baccarat</li>
                  <li className="flex items-center gap-2"><Zap className="w-3 h-3 text-[#003da5]" /> Game show hry (Crazy Time, Monopoly Live)</li>
                </ul>
              </div>
              <div className="bg-[#f3f6fb] rounded-xl p-4">
                <h3 className="font-bold text-gray-900 text-sm mb-2">Doporučení pro mobilní live hry</h3>
                <ul className="space-y-1 text-gray-600 text-sm">
                  <li className="flex items-center gap-2"><CheckCircle className="w-3 h-3 text-green-600" /> Stabilní Wi-Fi připojení (min. 5 Mbps)</li>
                  <li className="flex items-center gap-2"><CheckCircle className="w-3 h-3 text-green-600" /> Displej alespoň 5" pro pohodlné ovládání</li>
                  <li className="flex items-center gap-2"><CheckCircle className="w-3 h-3 text-green-600" /> Režim na šířku pro stolní hry</li>
                  <li className="flex items-center gap-2"><CheckCircle className="w-3 h-3 text-green-600" /> Automatické ztlumení ostatních aplikací</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section data-testid="section-trust-mobilni">
          <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-2xl p-6 shadow-sm">
            <h2 className="text-2xl font-black text-gray-900 mb-2 flex items-center gap-2">
              <Award className="w-6 h-6 text-[#003da5]" /> Proč tyto kasina doporučujeme
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-5">
              Každé mobilní kasino v našem přehledu prochází redakčním ověřením zaměřeným na mobilní kvalitu a spolehlivost:
            </p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { icon: Shield, title: "Ověřená licence", desc: "Platná licence od uznávaného regulátora je základní podmínkou pro zařazení do seznamu." },
                { icon: Clock, title: "Rychlost výplat", desc: "Testujeme reálné doby výběrů na mobilních zařízeních — preferujeme kasina s rychlými výplatami." },
                { icon: Gamepad2, title: "Mobilní optimalizace", desc: "Plynulý výkon, responzivní design a kompatibilita se současnými zařízeními." },
                { icon: Headphones, title: "Mobilní podpora", desc: "Dostupný live chat přímo z mobilního prohlížeče s rychlou odezvou." },
              ].map(({ icon: Icon, title, desc }) => (
                <div key={title} className="bg-white rounded-xl p-4 border border-[#dde4ee]">
                  <Icon className="w-8 h-8 text-[#003da5] mb-3" />
                  <div className="font-bold text-gray-900 text-sm mb-1">{title}</div>
                  <p className="text-gray-600 text-xs leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="casino-list">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-black text-gray-900 mb-2" data-testid="heading-casino-list-mobilni">Mobilní kasina — přehled</h2>
            <p className="text-gray-500 text-base">Kasina seřazená podle mobilní dostupnosti a kvality</p>
          </div>

          <div className="mb-6">
            <div className="bg-green-50 border border-green-200 rounded-2xl p-5 mb-4">
              <h3 className="font-black text-gray-900 text-lg mb-3 flex items-center gap-2">
                <Download className="w-5 h-5 text-green-700" /> Kasina s nativní mobilní aplikací
              </h3>
              {CASINOS.filter(c => c.hasApp).map((casino, i) => (
                <div key={casino.name} className="bg-white rounded-xl border border-green-100 p-4 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`mobilni-app-casino-${i}`}>
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
                      <img src={casino.logo} alt={casino.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-black text-gray-900 text-sm">{casino.name}</div>
                      <div className="flex items-center gap-1 text-xs text-green-700 font-semibold">
                        <Download className="w-3 h-3" /> Nativní aplikace — {casino.platforms}
                      </div>
                      <div className="text-[#003da5] font-bold text-sm mt-1">{casino.bonus}</div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <a href={casino.url} target="_blank" rel="sponsored noopener noreferrer">
                      <Button size="sm" className="hraj-btn font-bold gap-1.5 text-white" style={{ background: "#003da5" }} data-testid={`button-mobilni-hraj-app-${i}`}>
                        Hrát <ArrowRight className="hraj-arrow w-3.5 h-3.5" />
                      </Button>
                    </a>
                    <a href={casino.reviewUrl}>
                      <Button size="sm" variant="outline" className="hraj-btn-light font-semibold text-[#003da5]">
                        <BookOpen className="w-3.5 h-3.5" />
                      </Button>
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-2xl border border-[#dde4ee] p-5 shadow-sm">
              <h3 className="font-black text-gray-900 text-lg mb-3 flex items-center gap-2">
                <Wifi className="w-5 h-5 text-[#003da5]" /> Kasina optimalizovaná pro mobilní prohlížeč
              </h3>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {CASINOS.filter(c => !c.hasApp).map((casino, i) => (
                  <div
                    key={casino.name}
                    className="bg-[#f9fafb] rounded-xl border border-[#eef1f7] p-4 hover:shadow-md transition-shadow"
                    data-testid={`mobilni-browser-casino-${i}`}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
                        <img src={casino.logo} alt={casino.name} className="w-full h-full object-cover" />
                      </div>
                      <div className="min-w-0">
                        <div className="font-black text-gray-900 text-sm truncate">{casino.name}</div>
                        <div className="flex items-center gap-1 text-xs text-gray-500">
                          <Wifi className="w-3 h-3" /> {casino.platforms}
                        </div>
                      </div>
                    </div>
                    <div className="bg-[#eef3ff] rounded-lg px-3 py-2 mb-3">
                      <span className="text-[#003da5] font-bold text-sm">{casino.bonus}</span>
                    </div>
                    <div className="flex gap-2">
                      <a href={casino.url} target="_blank" rel="sponsored noopener noreferrer" className="flex-1">
                        <Button size="sm" className="hraj-btn w-full font-bold gap-1.5 text-white" style={{ background: "#003da5" }} data-testid={`button-mobilni-hraj-browser-${i}`}>
                          Hrát <ArrowRight className="hraj-arrow w-3.5 h-3.5" />
                        </Button>
                      </a>
                      <a href={casino.reviewUrl}>
                        <Button size="sm" variant="outline" className="hraj-btn-light font-semibold text-[#003da5]">
                          <BookOpen className="w-3.5 h-3.5" />
                        </Button>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-600" /> Výhody mobilního hraní
              </h2>
              <ul className="space-y-2">
                {[
                  "Hrajte kdykoli a odkudkoli — doma, na cestách, v přestávce",
                  "Exkluzivní mobilní bonusy u vybraných kasin",
                  "Mobilní platby (Apple Pay, Google Pay) pro rychlé vklady",
                  "Dotykové ovládání — intuitivní a přirozené",
                  "Push notifikace o nových bonusech (u aplikací)",
                  "Možnost přidat kasino na plochu jako zkratku",
                ].map(item => (
                  <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
              <h2 className="text-xl font-black text-gray-900 mb-4 flex items-center gap-2">
                <XCircle className="w-5 h-5 text-red-500" /> Omezení mobilního hraní
              </h2>
              <ul className="space-y-2">
                {[
                  "Menší obrazovka — méně pohodlné pro složitější stolní hry",
                  "Závislost na kvalitě internetového připojení",
                  "Vyšší spotřeba baterie při delším hraní",
                  "Live kasino spotřebovává více mobilních dat",
                  "Některé starší hry nemusí být plně optimalizovány",
                  "Omezené multitasking možnosti oproti desktopu",
                ].map(item => (
                  <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                    <span className="text-red-400 font-bold mt-0.5 flex-shrink-0">−</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 shadow-sm">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-6 h-6 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <h2 className="text-xl font-black text-gray-900 mb-2">Zodpovědné hraní na mobilu</h2>
                <p className="text-gray-700 text-sm leading-relaxed mb-3">
                  Mobilní dostupnost kasin znamená, že je ještě důležitější dodržovat zásady zodpovědného hraní. Snadný přístup k hrám z kapsy může vést k impulzivnímu hraní:
                </p>
                <ul className="space-y-1.5 text-gray-700 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Nastavte si denní a týdenní limity přímo v kasinu
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Vypněte push notifikace, pokud vás lákají k nadměrnému hraní
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Nikdy nehrajte pod vlivem alkoholu nebo ve stresu
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Pokud potřebujete pomoc, obraťte se na{" "}
                    <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="text-[#003da5] hover:underline font-semibold" data-testid="link-gamcare-mobilni">GamCare</a>{" "}
                    nebo{" "}
                    <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="text-[#003da5] hover:underline font-semibold" data-testid="link-gambleaware-mobilni">GambleAware</a>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-600 font-bold mt-0.5">•</span>
                    Využijte funkci sebeomezení nebo dočasného vyloučení
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="faq">
          <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
            <div className="flex items-center gap-2 mb-4">
              <HelpCircle className="w-5 h-5 text-[#003da5]" />
              <h2 className="text-2xl font-black text-gray-900" data-testid="heading-faq-mobilni">Časté dotazy o mobilních kasinech</h2>
            </div>
            {FAQ.map(item => (
              <FaqItem key={item.q} q={item.q} a={item.a} />
            ))}
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
}